import React from "react";
import { Navigate, useLocation } from "react-router-dom";

// /success and /free-success retired (founder pick 1A): the
// confirmation is now the live card on My Requests. Every old link — fan
// emails, pushes, Stripe Checkout / redirect return URLs, the app's own
// history — lands here and is forwarded with its params intact, so nothing
// in flight breaks and no bookmark dead-ends.
//   /success?order_id=X            → /fan/requests?order=X
//   /success?session_id=cs_…       → /fan/requests?session_id=cs_…
//   + redirect_status / payment_intent / payment_intent_client_secret / slug
const PASS = ["session_id", "redirect_status", "payment_intent", "payment_intent_client_secret", "slug"];

const LegacySuccessRedirect: React.FC = () => {
  const { search } = useLocation();
  const from = new URLSearchParams(search);
  const to = new URLSearchParams();
  const order = from.get("order_id") || from.get("order");
  if (order) to.set("order", order);
  for (const k of PASS) {
    const v = from.get(k);
    if (v) to.set(k, v);
  }
  const qs = to.toString();
  return <Navigate replace to={`/fan/requests${qs ? `?${qs}` : ""}`} />;
};

export default LegacySuccessRedirect;
